import { render, staticRenderFns } from "./parameterData.vue?vue&type=template&id=234244df&scoped=true&"
import script from "./parameterData.vue?vue&type=script&lang=js&"
export * from "./parameterData.vue?vue&type=script&lang=js&"
import style0 from "./parameterData.vue?vue&type=style&index=0&id=234244df&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234244df",
  null
  
)

export default component.exports